import { render } from "./DownloadPdf.vue?vue&type=template&id=bc42ac8c&scoped=true"
import script from "./DownloadPdf.vue?vue&type=script&lang=js"
export * from "./DownloadPdf.vue?vue&type=script&lang=js"

import "./DownloadPdf.vue?vue&type=style&index=0&id=bc42ac8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc42ac8c"]])

export default __exports__